module.exports = __webpack_public_path__ + "img/ui-graphics.f50975a0.svg";